import React, { useRef, useEffect } from 'react';

export default function MapPicker({ lat, lng, onChange, postalCode, addressText = '' }) {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || mapRef.current) return;

    import('leaflet').then(({ default: L }) => {
      const hasCoordinates = lat && lng;
      const center = hasCoordinates ? [parseFloat(lat), parseFloat(lng)] : [19.4326, -99.1332];
      const map = L.map(containerRef.current, { attributionControl: false }).setView(center, hasCoordinates ? 15 : 11);

      // Nota: se omite attribution para quitar la marca de agua en el widget.
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '' }).addTo(map);

      if (hasCoordinates) {
        markerRef.current = L.circleMarker([parseFloat(lat), parseFloat(lng)], {
          radius: 8,
          color: '#8e272d',
          fillColor: '#8e272d',
          fillOpacity: 0.8,
        }).addTo(map);
      }

      map.on('click', (e) => {
        if (markerRef.current) markerRef.current.remove();
        markerRef.current = L.circleMarker([e.latlng.lat, e.latlng.lng], {
          radius: 8,
          color: '#8e272d',
          fillColor: '#8e272d',
          fillOpacity: 0.8,
        }).addTo(map);
        onChange(e.latlng.lat.toFixed(6), e.latlng.lng.toFixed(6));
      });

      mapRef.current = map;
    });

    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!postalCode || postalCode.length !== 5 || !mapRef.current) return;

    fetch(
      `https://nominatim.openstreetmap.org/search?postalcode=${encodeURIComponent(postalCode)}&countrycodes=mx&format=json&limit=1`,
      { headers: { 'Accept-Language': 'es' } }
    )
      .then(r => r.json())
      .then(data => {
        if (data.length > 0 && mapRef.current) {
          mapRef.current.setView([parseFloat(data[0].lat), parseFloat(data[0].lon)], 14);
        }
      })
      .catch(() => {});
  }, [postalCode]);

  return (
    <div>
      <div ref={containerRef} className="map-picker" />
      {lat && lng
        ? (
          <p className="map-coords">
            {addressText ? `Direccion: ${addressText}` : `Coordenadas: ${lat}, ${lng}`} -{' '}
            <a
              href={`https://www.openstreetmap.org/?mlat=${encodeURIComponent(lat)}&mlon=${encodeURIComponent(lng)}&zoom=16`}
              target="_blank"
              rel="noreferrer"
            >
              Ver en mapa
            </a>
          </p>
        )
        : <p className="map-hint">Haz clic en el mapa para marcar la ubicación exacta</p>
      }
    </div>
  );
}
